import React from 'react';
import propTypes from 'prop-types';
import {
  Alert,
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from 'reactstrap';

const listingLabel = (sale) => {
  const userSell = sale && sale.offer && sale.offer.user_sell;
  const userSellId = userSell && userSell.id != null ? String(userSell.id) : '-';
  const fromListing = userSell && userSell.consignment_id;
  const fromSale = sale && sale.sale_product && sale.sale_product.consignment_id;
  const consignmentId = fromListing || fromSale;
  return `${userSellId} | ${consignmentId ? String(consignmentId) : '-'}`;
};

const ModalRelistListing = ({ isOpen, sale, isSubmitting, error, onCancel, onConfirm }) => {
  const dismiss = isSubmitting ? undefined : onCancel;
  const invoice = sale && sale.invoice_number ? sale.invoice_number : 'this sale';

  return (
    <Modal isOpen={isOpen} toggle={dismiss} className="modal-dialog modal-md">
      <ModalHeader toggle={dismiss}>Relist listing</ModalHeader>
      <ModalBody>
        <p className="mb-0">
          Restore the quantity for <strong>{invoice}</strong> to its original listing
          {' '}(<strong>{listingLabel(sale)}</strong>).
          This is for a marketplace order that has requested/atur pickup but the buyer cancelled afterwards.
        </p>
        {error && (
          <Alert color="danger" className="mt-3 mb-0">
            {error}
          </Alert>
        )}
      </ModalBody>
      <ModalFooter>
        <Button color="warning" disabled={isSubmitting || !sale} onClick={onConfirm}>
          {isSubmitting ? 'Relisting...' : 'Relist'}
        </Button>{' '}
        <Button color="secondary" disabled={isSubmitting} onClick={onCancel}>Cancel</Button>
      </ModalFooter>
    </Modal>
  );
};

ModalRelistListing.propTypes = {
  isOpen: propTypes.bool,
  sale: propTypes.object,
  isSubmitting: propTypes.bool,
  error: propTypes.string,
  onCancel: propTypes.func.isRequired,
  onConfirm: propTypes.func.isRequired,
};

ModalRelistListing.defaultProps = {
  isOpen: false,
  sale: null,
  isSubmitting: false,
  error: null,
};

export default ModalRelistListing;
